import React from 'react';
import { injectLazyLibs } from '@plone/volto/helpers/Loadable/Loadable';

const renderLegend = (colors, labels) => {
  return (
    <ul style={{ listStyleType: 'none', textAlign: 'left' }}>
      {colors.map((color, index) => (
        <li
          key={`item-${index}`}
          style={{
            width: '33%',
            fontSize: '60%',
            textAlign: 'left',
            display: 'inline-block',
          }}
        >
          <div
            style={{
              width: 10,
              height: 10,
              backgroundColor: color,
              display: 'inline-block',
              marginRight: 5,
              verticalAlign: 'middle',
            }}
          ></div>
          {labels['v' + index]}
        </li>
      ))}
    </ul>
  );
};

const Chart = ({ data, locale, recharts }) => {
  const colors = data.shift();
  colors.shift();
  const labels = data.shift();
  const {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Label,
    CartesianGrid,
    Legend,
    LabelList,
    ResponsiveContainer,
  } = recharts;

  return (
    <div>
      <ResponsiveContainer
        width={900}
        height={500}
        className="grouped-bar-chart"
      >
        <BarChart
          data={data}
          margin={{
            top: 30,
            right: 30,
            left: 20,
            bottom: 10,
          }}
        >
          <Label
            angle={0}
            offset={5}
            position="center"
            value="Position: center"
            zIndex={2000}
          />
          <CartesianGrid vertical={false} />
          <Legend content={renderLegend(colors, labels)} />

          <XAxis
            dataKey="name"
            style={{ fontSize: '60%' }}
            tickLine={{ stroke: 'rgb(204, 204, 204)' }}
            axisLine={{ stroke: 'rgb(204, 204, 204)' }}
            tickSize={16}
          />
          <YAxis
            type="number"
            axisLine={false}
            tickLine={false}
            style={{ fontSize: '60%' }}
          />
          {colors.map((color, index) => (
            <Bar
              dataKey={`v${index}`}
              fill={color}
              key={`bar-${index}`}
              barSize="12"
            >
              <LabelList
                dataKey={`v${index}`}
                position="top"
                style={{
                  fontSize: '60%',
                  textAnchor: 'start',
                  fontWeight: 'bold',
                  fill: '#000000',
                  transformOrigin: '1px -2px',
                }}
                angle={-90}
                formatter={(value) =>
                  Intl.NumberFormat(locale, {
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                  }).format(value)
                }
              />
            </Bar>
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default injectLazyLibs('recharts')(Chart);
